<template>
  <div class="page">
    <NavigationBar v-if="!userStore.isLogin" :title="$t('message.title')">
    </NavigationBar>
    <div class="page-content" :style="`padding-top: ${envStore.statusBarHeight}px`">
      <ImMessageBox v-if="routeRoomId" :room-id="routeRoomId" :home-top-height="homeTopHeight"
        :page-padding-top="envStore.pagePaddingTop" :connect-params="$route.query" @ready="onIMReady" />
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * 单个会话页
 */
import { ref, onMounted, onActivated } from 'vue'
import { useRoute } from 'vue-router';
import { logAFEvent } from '@voghion/native-api'
import { useRouterAdv } from '@/composables/use-router-adv'
import { useEnvStore } from '@/states/env'
import { useUserStore } from '@/states/user'
import { getUserInfo } from '@/api/user'
import ImMessageBox from '@/components/ImMessageBox/ImMessageBox.vue'
import NavigationBar from '../components/NavigationBar.vue'

const route = useRoute();
const routerAdv = useRouterAdv()
const envStore = useEnvStore()
const userStore = useUserStore()

const routeRoomId = ref(Number(route.params.id))
const homeTopHeight = ref(0)
const currentRoomId = ref(0)
const pageShow = ref(false)

onMounted(() => {
  if (!routeRoomId.value) {
    routerAdv.replace({
      path: '/',
      query: route.query
    })
  }
  setTimeout(() => {
    getUserInfo()
  }, 1000)
})

onActivated(() => {
  if (pageShow.value) {
    trackPageView()
  }
})

const trackPageView = () => {
  logAFEvent({
    event: 'showSPM',
    spm: '01010470000',
    spmName: 'chatPage',
    params: {
      conversationId: currentRoomId.value,
      url: window.location.href
    }
  })
}

const onIMReady = (conversationId: number) => {
  currentRoomId.value = conversationId
  if (!pageShow.value) {
    pageShow.value = true
    trackPageView()
  }
}
</script>

<style lang="scss">
.page {
  height: 100vh;
}

.page-content {
  height: 100%;
  box-sizing: border-box;

  :deep(.empty-wrapper) {
    padding-top: 100px;
  }
}
</style>